export default "//cloud.imgsmail.ru/cloud.mail.ru/188971/img/build/subscriptions/cancel-autorenew.png";